import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CreateFormModalPage } from './modal-create-form';

@NgModule({
    declarations: [
        CreateFormModalPage,
    ],
    imports: [
        IonicPageModule.forChild(CreateFormModalPage)
    ],
    entryComponents: [
        CreateFormModalPage,
    ]
})
export class CreateFormDetailsModule { }


// WEBPACK FOOTER //
// ./src/pages/modal-create-form/modal-create-form.module.ts